import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  DocumentEntity,
  HeaderDocumentsService,
} from '@products/fund-header/services/header-documents.service';
import { AppStateService } from '@services/app-state.service';
import { ProfileService } from '@services';
@Component({
  selector: 'ft-literature-preview',
  templateUrl: './literature-preview.component.html',
  styleUrls: ['./literature-preview.component.scss'],
})
export class LiteraturePreviewComponent implements OnInit, OnDestroy {
  public documents: DocumentEntity[];
  private unsubscribe$: Subject<void> = new Subject<void>();
  private widenUrl: string;
  private litPreviewUrl: string;
  isLoggedIn: boolean;

  constructor(
    private headerDocumentsService: HeaderDocumentsService,
    private appStateService: AppStateService,
    private profileService: ProfileService
  ) {
    // TODO: to check if user open page and then logged in without page reload
    this.profileService
      .isLoggedIn$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
      });
  }

  ngOnInit(): void {
    this.documents = [];
    this.widenUrl = this.appStateService.getWidenUrl();
    this.litPreviewUrl = this.appStateService.getLiteratureDownloadPreviewUrl();

    // important - this will be resolved after documents section (literature-fund-document.component) is loaded
    this.headerDocumentsService.documentPreviewData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((documents: DocumentEntity[]) => {
        this.documents = this.getMappedDocuments(documents);
      });
  }

  // process documents and replace required paths
  getMappedDocuments(documents: DocumentEntity[]): DocumentEntity[] {
    return documents.map((doc) => {
      return {
        ...doc,
        pdfLink: this.createLitDownloadPath(doc.customFilePath),
      };
    });
  }

  createLitDownloadPath(litCode: string) {
    return this.litPreviewUrl + litCode;
  }
  // replaces absolute path to local path
  replaceWidenPath(path: string): string {
    let replacedPath = path.replace(this.widenUrl, '/dam/');
    // this will be removed after we migrate all documents to widen.
    replacedPath = replacedPath.replace(
      'https://www.franklintempleton.com/',
      '/'
    );
    return replacedPath;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
